module.exports = __webpack_public_path__ + "img/header_en.660aa353.png";